import React from "react";

export const HeroBanner = () => {
  return (
    <div className="hero-banner">
      <h1 className="hero-banner__headline">SonoFlex</h1>
      <p className="hero-banner__description">
        Landing page.
      </p>
    </div>
  );
};
